import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import useClearOrganizationContext from '@/hooks/super-admin/useClearOrganizationContext';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ClearOrganizationContextConfirmationModal = ({ isOpen, onClose }: Props) => {
  const { isPending, mutate } = useClearOrganizationContext();

  return (
    <ModalContainer isOpen={isOpen} onClose={onClose} title="Clear Organization" overflowY="hidden">
      <VStack alignItems={'center'} gap={'20px'}>
        <VStack gap={'10px'}>
          <Text color={'text.mediumBlue'} fontSize={'20px'} textAlign="center">
            Are you sure you want to clear the organization context?
          </Text>
          <Text variant={'urbanistSemiBold'} color={'text.mediumBlue'} fontSize={'20px'}>
            This will remove the current organization context from your session.
          </Text>
        </VStack>
        <Text variant={'urbanistTitleMedium'} color={'text.darkBlue'} fontSize={'16px'}>
          Please confirm your action.
        </Text>
        <CustomButton label="Confirm" backgroundColor="extra.red" onClick={mutate} isLoading={isPending} />
      </VStack>
    </ModalContainer>
  );
};

export default ClearOrganizationContextConfirmationModal;
